/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:54:39
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiEnum - apply enum to element.

@UITag.set()
export class uiEnum extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = false;

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        if (rule == null) return null;

        /// normal case
        return {
            props: { options: rule },
        };
    }
}
